import blockchainConfig, { INetwork } from './blockchain.config';

export interface IEndpoint {
  ws: string;
  rest: string;
  gatekeeper: string;
}

export interface ISamurai {
  name: string;
  commitHash: string;
  scssVariables: string;
  homeURL: string;
  logoURL: string;
  contactEmail: string;
  network: INetwork;
}

export interface ISentryConfig {
  enabled: boolean;
  dsn: string;
}

export interface IAppConfig {
  samurai: ISamurai;
  endpoints: IEndpoint;
  sentry: ISentryConfig;
}

export const appConfig: IAppConfig = {
  samurai: {
    name: 'Mining Puppets',
    commitHash: process.env.COMMIT_HASH || '<unset>',
    scssVariables: './src/styles/whitelabel-variables/light',
    homeURL: 'https://user.luxtag.io',
    logoURL: './src/assets/img/mining-puppet-logo.png',
    contactEmail:  'info@luxtag.io',
    network: blockchainConfig.mijin_test,
  },
  sentry: {
    enabled: process.env.ENABLE_SENTRY ? true : false,
    dsn: 'https://862bccac5bd345a4944198b6a2d26492@sentry.luxtag.io/2',
  },
  endpoints: {
    ws: 'wss://internal.luxtag.io/samurai-ws',    // staging endpoint
    rest: 'http://localhost:8883/rest/v1',        // mountebank mock
    gatekeeper: 'http://localhost:8881/rest/v1',  // mountebank mock
  }
};
